import React from 'react';
import { inject, observer } from 'mobx-react';
import { WeaLocaleProvider } from 'ecCom';

import './style';
import E9Header from '../layout2/E9Header';
import E9LeftMenu from './E9LeftMenu';

const getLabel = WeaLocaleProvider.getLabel;

@inject('portalThemeStore')
@observer
class E9ThemeLayout3 extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { portalThemeStore, location } = this.props;
    const { pathname, query } = location;
    portalThemeStore.getTopMenu(pathname, query);
  }

  render() {
    const { portalThemeStore } = this.props;
    const { searchParams, themeInfo, translatepage } = portalThemeStore;
    const { hideHeader, hideAside } = searchParams;
    const { themeColorType } = themeInfo;
    const colorClassName = themeColorType ? `e9theme-color-${themeColorType}` : '';

    let contenttop = '';
    if (hideHeader == 'true') {
      contenttop = translatepage == '1' ? '30px' : '0px';
    } else {
      contenttop = translatepage == '1' ? '85px' : '55px';
    }

    return (
      <div className={`e9theme-layout3-container ${colorClassName}`}>
        {translatepage == '1' ? (
          <div className="e9theme-translate">
            <div className="trans-tips">{getLabel(518684, '您已进入翻译模式，点击高亮显示的页面文字即可进行翻译')}</div>
            <div className="trans-exit" onClick={this.exitTranslatepage}>
              {getLabel(518685, '退出翻译模式')}
            </div>
          </div>
        ) : null}
        {hideHeader == 'true' ? null : (
          <div className="e9theme-layout3-header" style={translatepage == '1' ? { top: '30px' } : { top: '0px' }}>
            <E9Header ecId={`${(this && this.props && this.props.ecId) || ''}_E9Header@1g05c5`} />
          </div>
        )}
        <div className="e9theme-layout3-content" style={{ top: contenttop }}>
          <div id="themeLayoutMask" className="e9theme-layout3-mask" />
          {hideAside == 'true' ? null : (
            <div className="e9theme-layout3-left">
              <E9LeftMenu ecId={`${(this && this.props && this.props.ecId) || ''}_E9LeftMenu@zdgecl`} />
            </div>
          )}
          <div className="e9theme-layout3-main" style={hideHeader == 'true' && hideAside == 'true' ? { padding: 0 } : {}}>
            <div id="themeLayoutRoute" className="e9theme-layout3-route">
              {this.props.children}
            </div>
            <div id="themeLayoutFrame" className="e9theme-layout3-frame">
              <iframe id="mainFrame" name="mainFrame" src="about:blank" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  exitTranslatepage = () => {
    const { portalThemeStore } = this.props;
    portalThemeStore.setTranslatepage(0);
  };
}

export default E9ThemeLayout3;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/layout3/index.js